import React, { useMemo, useState,  useContext } from 'react';
import Context from "../context/context";




const FilterTotals = props => {

  const {pagination, currentPage, totalItems, language} = useContext(Context);

  





  return (
    <>
      <div className="filter-results">
        <div className="filter-totals num-results">Results ({totalItems})</div>

      </div>
    </>
  )
}

export default FilterTotals;
